/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { ActiveTestsCardTest } from 'cio/components/campaign-overview-page/active-tests-card';
import { findDenominator, MeasureType } from 'cio/utils/metrics/measure';
import { action } from '@ember/object';
import CampaignModel from 'cio/models/campaign';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';
import { ClickSource } from 'cio/utils/analytics/transforms/campaign';

interface CampaignOverviewPageActiveTestsCardRowArgs {
  campaign: CampaignModel;
  test: ActiveTestsCardTest;
}

export default class CampaignOverviewPageActiveTestsCardRow extends Component<CampaignOverviewPageActiveTestsCardRowArgs> {
  @service analytics!: AnalyticsService;

  readonly measures = ['opened', 'clicked', 'converted'];

  get denominator() {
    return findDenominator('converted', MeasureType.DeliveryMetrics, 'email_action');
  }

  @action
  trackStarIconHover() {
    this.analytics.track('campaign', 'ab_test_star_icon_hovered', {
      model: this.args.campaign,
      action: this.args.test.action,
    });
  }

  @action
  trackLinkClick() {
    this.analytics.track('campaign', 'ab_tests_tab_viewed', {
      model: this.args.campaign,
      source: ClickSource.OverviewABTestCard,
    });
  }
}
